import { type FC, useCallback } from 'react';

import { MAP_ZOOM_DURATION } from '../../../constants/map';
import { useMapStoreContext } from '../../../context/mapStoreContext';

import { ZoomOut } from './ZoomOut';

export const ZoomOutContainer: FC = () => {
  const { map } = useMapStoreContext();

  const handleClick = useCallback(() => {
    if (map) {
      const zoom = map.getZoom();
      const [minZoom] = map.zoomRange.getCurrent();

      if (zoom <= minZoom) {
        return;
      }

      map.setZoom(zoom - 1, { duration: MAP_ZOOM_DURATION });
    }
  }, [map]);

  return <ZoomOut handleClick={handleClick} />;
};
